import * as React from "react";

import { useGetSvgIconFill } from "@intelligems/ig-theme/hooks/use-get-svg-icon-fill";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const WebTraffic = (props: SvgIconProps) => {
  const fill = useGetSvgIconFill(props.color);

  return (
    <SvgIcon {...props}>
      <svg
        width={35}
        height={35}
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect width={35} height={35} rx={5} fill="white" />
        <rect width={35} height={35} rx={5} fill={fill} fillOpacity={0.08} />
        <path
          d="M8.5 18V16H11.5V18H8.5ZM11.9 23.55L10.5 22.1L12.6 20L14.05 21.4L11.9 23.55ZM12.6 14L10.5 11.9L11.9 10.45L14.05 12.6L12.6 14ZM24.5 26L19.75 21.25L18.5 25L15.5 15L25.5 18L21.8 19.3L26.5 24L24.5 26ZM16.5 12V9H18.5V12H16.5ZM22.4 14L20.95 12.6L23.1 10.45L24.5 11.85L22.4 14Z"
          fill={fill}
          fillOpacity={0.38}
        />
      </svg>
    </SvgIcon>
  );
};
